module.exports = __webpack_public_path__ + "img/award.097dac02.svg";